import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
export const DragHandle = ({ listeners, attributes, blockId }) => {
    return (_jsx("button", { type: "button", className: "vehicle-layout-drag-handle p-2 rounded-xl", style: {
            background: 'rgba(255,255,255,0.8)',
            border: '1px solid rgba(203,213,225,0.8)',
            color: 'rgba(71,85,105,0.9)',
            cursor: 'grab',
            touchAction: 'none',
        }, title: "\u0633\u062D\u0628 \u0644\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u0643\u0627\u0646", ...attributes, ...listeners, "data-testid": `layout-drag-handle-${blockId}`, children: _jsx("span", { className: "text-lg leading-none", children: "\u22EE\u22EE" }) }));
};
export const SortableBlock = ({ id, title, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.75 : 1,
    };
    return (_jsx("div", { ref: setNodeRef, style: style, "data-testid": `layout-block-${id}`, children: _jsxs("div", { className: "vehicle-layout-block liquid-surface mx-3 sm:mx-0 backdrop-blur-xl", style: {
                borderRadius: 22,
                padding: 12,
                background: 'rgba(241,245,249,0.8)',
                border: '1px solid rgba(203,213,225,0.8)',
                boxShadow: '0 18px 60px rgba(2,6,23,0.55)',
            }, children: [_jsxs("div", { className: "vehicle-layout-block-header flex items-center justify-between gap-3 mb-2", children: [_jsx("div", { className: "min-w-0", children: _jsx("div", { className: "text-[13px] font-extrabold truncate", style: { color: 'rgba(15,23,42,0.95)' }, "data-testid": `layout-block-title-${id}`, children: title }) }), _jsx(DragHandle, { listeners: listeners, attributes: attributes, blockId: id })] }), _jsx("div", { children: children })] }) }));
};
